import { AfterViewInit, Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as debounce from 'lodash/debounce';

import { QuickNavToc, QuickNavTocEntry } from '../models/quick-nav-toc.model';
import { PinSearchbarService } from '../services/pin-searchbar.service';
import { storageAvailable } from '../../util/helpers';
import { HostListener } from '@angular/core';

/**
 * Offset amount to use when scrolling or checking the viewport status to account for the fixed header.
 */
const OFFSET = 60;


@Component({
  selector: 'app-quick-nav',
  templateUrl: './quick-nav.component.html',
  styleUrls: ['./quick-nav.component.scss']
})
export class QuickNavComponent implements AfterViewInit {
  /**
   * Table of contents for the quick nav
   */
  @Input() toc: QuickNavToc;

  @ViewChild('sticky', { read: ElementRef }) stickyEl: ElementRef;
  @ViewChild('wrapper') navWrapper: ElementRef;

  activeEntry: QuickNavTocEntry;
  $navWrapper: any;
  $page: any;
  $sections: any;
  private _fragment: string;
  private searchbarPinned = false;
  screenWidth: number;
  topOffset = 56;

  constructor(
    private _route: ActivatedRoute,
    private _zone: NgZone,
    private _pinSearchbarService: PinSearchbarService
  ) {
    this.onResize();
  }

  ngAfterViewInit() {
    this._route.fragment.subscribe(fragment => {
      this._fragment = fragment;
      this.scrollToSection(fragment);
    });

    // Initialize jQuery elements
    // @ts-ignore
    this.$navWrapper = $(this.navWrapper.nativeElement);
    this.$page = this.$navWrapper.closest('.detail-page');
    this.$sections = this.$page.find('.scroll-spy-section');

    if (storageAvailable('localStorage')) {
      const storageVal = localStorage.getItem('searchbarPinned');
      this.searchbarPinned = storageVal === 'true';
    }

    if (this.screenWidth != null && this.screenWidth < 760) {
      this.topOffset = 48;
    }

    // Initialize sticky behavior and event handler
    this._zone.runOutsideAngular(() => {
      this.$navWrapper.stick_in_parent({
        parent: this.$page,
        offset_top: this.searchbarPinned ? this.topOffset : 0
      });

      setTimeout(() => this.updateActiveEntry(), 50);
      // @ts-ignore
      $(window).on('resize scroll', debounce(this.updateActiveEntry.bind(this), 50));
    });

    this._pinSearchbarService.pinSearchbarClickedEvent.subscribe(pinned => {
      this.searchbarPinned = pinned;

      this.$navWrapper.trigger('sticky_kit:detach');
      this.$navWrapper.stick_in_parent({
        parent: this.$page,
        offset_top: this.searchbarPinned ? this.topOffset : 0
      });
    });
  }

  updateActiveEntry() {
    const entry = this.getFirstSectionInViewport();
    if (entry !== this.activeEntry) {
      this._zone.run(() => this.activeEntry = entry);
    }
  }

  getFirstSectionInViewport(): QuickNavTocEntry {
    for (const section of this.$sections) {
      // @ts-ignore
      const $section = $(section);
      if ($section['isInViewport'](OFFSET * 2)) {
        const id = $section.attr('id');
        return this.toc.entries.filter(e => e.fragment === id)[0];
      }
    }
    return null;
  }

  scrollToSection(fragment: string) {
    if (!fragment) {
      return;
    }
    // @ts-ignore
    const $target = $('#' + fragment);
    if ($target.length) {
      const top = $target.offset().top - OFFSET;
      // @ts-ignore
      $('html, body').animate({ scrollTop: top }, 500);
    }
  }

  onEntryClick (entry: QuickNavTocEntry) {
    // If the current URL fragment matches the one that is clicked, it won't trigger a scroll, so trigger it
    // manually.
    if (this._fragment === entry.fragment) {
      this.scrollToSection(entry.fragment);
    }
  }

  @HostListener('window:resize', ['event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
    if (this.screenWidth != null && this.screenWidth < 760) {
      this.topOffset = 48;
    } else {
      this.topOffset = 56;
    }
    this._pinSearchbarService.pinSearchbarClicked(this.searchbarPinned);
  }
}
